;(function(){
  'use strict';
  if(window.__SHProductReviewJumpV108)return;
  window.__SHProductReviewJumpV108=true;

  var HERO_SELECTOR='.sh-studio .buy__meta[data-sh-scroll-reviews]';
  var FULL_SELECTOR='.sh-studio [data-sh-full-reviews-open]';
  var CUE_SELECTOR='.sh-review-jump-v106';
  var APP_SELECTOR='[data-sh-full-reviews-app]';
  var reducedMotion=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)');

  function qsa(selector,root){
    return Array.prototype.slice.call((root||document).querySelectorAll(selector));
  }

  function unique(nodes){
    return nodes.filter(function(node,index,list){return list.indexOf(node)===index;});
  }

  function heroButtons(scope){
    var root=scope&&scope.querySelectorAll?scope:document;
    var buttons=[];
    if(root.matches&&root.matches(HERO_SELECTOR))buttons.push(root);
    buttons=buttons.concat(qsa(HERO_SELECTOR,root));
    return unique(buttons);
  }

  function plainReviewLabel(button){
    var clone=button.cloneNode(true);
    qsa(CUE_SELECTOR,clone).forEach(function(cue){cue.remove();});
    return (clone.textContent||'Customer reviews').replace(/\s+/g,' ').trim();
  }

  function ensureCue(scope){
    heroButtons(scope||document).forEach(function(button){
      qsa(CUE_SELECTOR,button).forEach(function(cue){cue.remove();});
      button.setAttribute('aria-label',plainReviewLabel(button)+' — view product reviews');
    });
  }

  function findReviewApp(){
    var apps=qsa(APP_SELECTOR);
    if(!apps.length)return document.getElementById('ShFullReviews');
    var populated=apps.filter(function(app){
      return !!app.querySelector('.alireviews-review-box,.alr-wh-comp-review-box,[class*="alr-"],[class*="ali-review"]');
    });
    return populated[populated.length-1]||apps[apps.length-1];
  }

  function removeLegacySickHausReviewClasses(app){
    if(!app)return;
    qsa('.sh-ali-review-list,.sh-ali-review-card,.sh-ali-review-summary,.sh-ali-review-surface,.sh-ali-review-action',app).forEach(function(node){
      node.classList.remove('sh-ali-review-list','sh-ali-review-card','sh-ali-review-summary','sh-ali-review-surface','sh-ali-review-action');
    });
  }

  function revealReviewApp(app){
    if(!app)return;
    removeLegacySickHausReviewClasses(app);
    app.hidden=false;
    app.removeAttribute('hidden');
    app.classList.add('is-open','sh-native-alireviews-v108');
    app.setAttribute('aria-hidden','false');
    qsa('[data-sh-full-reviews-open]').forEach(function(button){button.setAttribute('aria-expanded','true');});
    try{window.dispatchEvent(new Event('resize'));}catch(error){}
  }

  function scrollToReviewApp(app){
    if(!app)return;
    var behavior=reducedMotion&&reducedMotion.matches?'auto':'smooth';
    window.requestAnimationFrame(function(){
      window.requestAnimationFrame(function(){
        try{app.scrollIntoView({behavior:behavior,block:'start'});}catch(error){app.scrollIntoView();}
      });
    });
    window.setTimeout(function(){
      try{window.dispatchEvent(new Event('resize'));window.dispatchEvent(new Event('scroll'));}catch(error){}
    },120);
    window.setTimeout(function(){
      removeLegacySickHausReviewClasses(app);
      try{window.dispatchEvent(new Event('resize'));}catch(error){}
    },420);
  }

  function openReviews(attempt){
    var app=findReviewApp();
    if(app){
      revealReviewApp(app);
      scrollToReviewApp(app);
      return;
    }
    attempt=attempt||0;
    if(attempt===0){
      var bottom=Math.max(document.body.scrollHeight,document.documentElement.scrollHeight);
      window.scrollTo({top:bottom,behavior:reducedMotion&&reducedMotion.matches?'auto':'smooth'});
    }
    if(attempt<12)window.setTimeout(function(){openReviews(attempt+1);},100);
  }

  function handleClick(event){
    var target=event.target&&event.target.closest?event.target.closest(HERO_SELECTOR+','+FULL_SELECTOR):null;
    if(!target)return;
    if(event.cancelable)event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    openReviews(0);
  }

  function prepare(){
    ensureCue(document);
    var app=findReviewApp();
    if(app)removeLegacySickHausReviewClasses(app);
  }

  window.addEventListener('click',handleClick,true);

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',prepare,{once:true});
  else prepare();
  window.addEventListener('load',function(){window.setTimeout(prepare,0);},{once:true});
  window.addEventListener('pageshow',function(){window.setTimeout(prepare,0);});
  document.addEventListener('shopify:section:load',function(){window.setTimeout(prepare,0);});
})();
